"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareStatusMaskT = exports.FirmwareStatusMask = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * A mask of the data in `FirmwareStatus`
 */
class FirmwareStatusMask {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsFirmwareStatusMask(bb, obj) {
        return (obj || new FirmwareStatusMask()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsFirmwareStatusMask(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new FirmwareStatusMask()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    errorStatus() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    tps() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    ping() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    rssi() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    mcuTemp() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    batteryVoltage() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    batteryPctEstimate() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startFirmwareStatusMask(builder) {
        builder.startObject(7);
    }
    static addErrorStatus(builder, errorStatus) {
        builder.addFieldInt8(0, +errorStatus, +false);
    }
    static addTps(builder, tps) {
        builder.addFieldInt8(1, +tps, +false);
    }
    static addPing(builder, ping) {
        builder.addFieldInt8(2, +ping, +false);
    }
    static addRssi(builder, rssi) {
        builder.addFieldInt8(3, +rssi, +false);
    }
    static addMcuTemp(builder, mcuTemp) {
        builder.addFieldInt8(4, +mcuTemp, +false);
    }
    static addBatteryVoltage(builder, batteryVoltage) {
        builder.addFieldInt8(5, +batteryVoltage, +false);
    }
    static addBatteryPctEstimate(builder, batteryPctEstimate) {
        builder.addFieldInt8(6, +batteryPctEstimate, +false);
    }
    static endFirmwareStatusMask(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createFirmwareStatusMask(builder, errorStatus, tps, ping, rssi, mcuTemp, batteryVoltage, batteryPctEstimate) {
        FirmwareStatusMask.startFirmwareStatusMask(builder);
        FirmwareStatusMask.addErrorStatus(builder, errorStatus);
        FirmwareStatusMask.addTps(builder, tps);
        FirmwareStatusMask.addPing(builder, ping);
        FirmwareStatusMask.addRssi(builder, rssi);
        FirmwareStatusMask.addMcuTemp(builder, mcuTemp);
        FirmwareStatusMask.addBatteryVoltage(builder, batteryVoltage);
        FirmwareStatusMask.addBatteryPctEstimate(builder, batteryPctEstimate);
        return FirmwareStatusMask.endFirmwareStatusMask(builder);
    }
    unpack() {
        return new FirmwareStatusMaskT(this.errorStatus(), this.tps(), this.ping(), this.rssi(), this.mcuTemp(), this.batteryVoltage(), this.batteryPctEstimate());
    }
    unpackTo(_o) {
        _o.errorStatus = this.errorStatus();
        _o.tps = this.tps();
        _o.ping = this.ping();
        _o.rssi = this.rssi();
        _o.mcuTemp = this.mcuTemp();
        _o.batteryVoltage = this.batteryVoltage();
        _o.batteryPctEstimate = this.batteryPctEstimate();
    }
}
exports.FirmwareStatusMask = FirmwareStatusMask;
class FirmwareStatusMaskT {
    constructor(errorStatus = false, tps = false, ping = false, rssi = false, mcuTemp = false, batteryVoltage = false, batteryPctEstimate = false) {
        this.errorStatus = errorStatus;
        this.tps = tps;
        this.ping = ping;
        this.rssi = rssi;
        this.mcuTemp = mcuTemp;
        this.batteryVoltage = batteryVoltage;
        this.batteryPctEstimate = batteryPctEstimate;
    }
    pack(builder) {
        return FirmwareStatusMask.createFirmwareStatusMask(builder, this.errorStatus, this.tps, this.ping, this.rssi, this.mcuTemp, this.batteryVoltage, this.batteryPctEstimate);
    }
}
exports.FirmwareStatusMaskT = FirmwareStatusMaskT;
